// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"Modal_tableContainer__2PgRQ","loading":"Modal_loading__3jkke","loadingSpinner":"Modal_loadingSpinner__3qXZR"};